import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { GlobalVariable } from "../../app.component";
import { DataService, Response } from "../../dataService/data.service";
import { CommonService } from "../../services/common.service";
import { forkJoin } from "rxjs";
import { FeaturesByPlanService } from "src/app/services/features-by-plan/features-by-plan.service";
import { SubFeatures } from "src/app/services/features-by-plan/interface/common";
import {
  ReviewStructure,
  REVIEW_SUBFEATURES,
} from "src/app/services/features-by-plan/interface/reviews";
import { ReviewsService } from "./../../reviews/reviews.service";
import { AlertService } from "../../services/alert.service";
import * as htmlToImage from "html-to-image";
import { MessagingService } from "src/app/messaging/messaging.service";

@Component({
  selector: "app-request-template",
  templateUrl: "./request-template.component.html",
  styleUrls: ["./request-template.component.scss"],
})
export class RequestTemplateComponent implements OnInit {
  public loading = false;
  private BASE_URL = GlobalVariable;
  logo_url: String;
  reviewTemplateForm: FormGroup;
  allTemplates: any = [];
  dataService: any;
  isValidFormSubmitted: boolean = true;
  elementType: "url" | "canvas" | "img" = "url";
  value: string;
  outlet_id: string;
  sendMsgSms: boolean = false;
  sendMsgEmail: boolean = false;
  sendMsgQr: boolean = false;
  sendMsgWhatsapp: boolean = false;
  button_name: String;
  button_image: any;
  closeResult: string;
  template_id: String;
  default_template_select: String;
  selected_template_id: String;
  qrcode_link: any;
  business_name: any;
  brandLogo: boolean = false;
  brandName: boolean = false;
  powerBy: boolean = false;
  qrCodeSettingForm: FormGroup;
  reviewEmailTemplateForm: FormGroup;
  email_template_html_data: any;
  role: string = this.storage.get("role");
  user_id: string = this.storage.get("user_id");
  // Personal (team-member tagged) review QR for the logged-in member/owner
  myQrUrl: string = "";
  myQrLoading: boolean = false;
  myQrError: string = "";
  show_button: boolean = false;
  show_button1: boolean = false;
  saveAsNewTemplateButton: boolean = false;
  smsMaxLength: number;
  smsMaxLength1: number = 130;
  smsMaxLengthEdit: number;
  smscount: any = [];
  reviewlinkcount: any = " {{review_link}}";
  review_contlen: any = "review_content";
  smsMaxLengthToastr: any;
  business_temp_logo: string =
    "https://zceppa-image-uploads.s3.ap-south-1.amazonaws.com/plain-white.jpg";
  showNoDefaultTemplate: boolean = false;
  showNoCustomTemplate: boolean = false;
  // wasClicked: any;
  whatsappTempList: any = [];
  reviewWhatsappForm: FormGroup;
  default_whatsapp_template: string;
  permissions: any;

  @ViewChild("saveAsNewTemplateModel", { read: ElementRef })
  saveAsNewTemplateModel: ElementRef;

  @ViewChild("input1", { read: ElementRef }) private _inputElement: ElementRef;
  interactWhatsapp: any;
  is_template_approved: any;
  is_reviews_blocked: any;
  reviews_warning_text: any = "";
  isDefaultTemplate: boolean = true;
  isApprovedTemplate: boolean;
  showDltWarning: void;
  isGenericTemplate: boolean = false;
  reviewFeatures: any;
  zceppaTempLen: number;
  requestChannels: string[] = [];
  customTempLen: number = 0;
  reviewStructure: ReviewStructure = {
    review_invite_channel: [
      "feature_reviews",
      REVIEW_SUBFEATURES.review_invite_channel,
      "is_applicable",
    ],
    zceppa_invite_template: [
      "feature_reviews",
      REVIEW_SUBFEATURES.zceppa_invite_template,
      "is_applicable",
    ],
    custom_invite_template: [
      "feature_reviews",
      REVIEW_SUBFEATURES.custom_invite_template,
      "is_applicable",
    ],
  };
  checkInternationalCountry: boolean;
  selectedTemplate = null;
  zceppaTemplatesSMS: any[] = [];
  customTemplatesSMS: any[] = [];
  emailTemplates: any[] = [];
  isCustomTemplatesAvailable: boolean;
  isDownloadQr: boolean;
  isDownloadMyQr: boolean;
  isWhatsAppChannelAvailableInSettings: boolean = false;
  predefinedVariables: any[] = [];
  locationName: boolean = false;
  outlet_name: string = "";
  dynamicVariable = [
    {
      variable_id: null,
      variable_name: "profile_name",
      variable_value: "test name",
      variable_display_name: "Name",
      variable_type: "TEXT",
    },
    {
      variable_name: "profile_detail",
      variable_value: "prof detail test",
      variable_id: null,
      variable_display_name: "Qualification",
      variable_type: "TEXT",
    },
    {
      variable_name: "profile_photo",
      variable_value: "",
      variable_id: null,
      variable_display_name: "Display Photo",
      variable_type: "MEDIA",
    },
  ];
  isUploading: boolean;
  media_url: any;
  show_powered_by_logo: boolean = false;

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private HttpService: DataService,
    public formBuilder: FormBuilder,
    private reviewsService: ReviewsService,
    private toastrService: ToastrService,
    private modalService: NgbModal,
    private commonservice: CommonService,
    private alertService: AlertService,
    private msgService: MessagingService,
    private featuresByPlan: FeaturesByPlanService
  ) {}

  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterViewInit(): void {
    setTimeout(() => {
      this._inputElement.nativeElement.focus();
    }, 1000);
  }

  public uploadFile(event, variable) {
    let isSizeError: boolean = false;
    let file = event.target.files[0];
    let fileSize = file?.size;
    fileSize = (fileSize / (1024 * 1024)).toFixed(2);
    if (fileSize > 25) {
      isSizeError = true;
    }

    if (isSizeError) {
      this.toastrService.error("Please follow the upload limits");
    } else {
      this.isUploading = true;
      let filename = file.name;
      let formData = new FormData();

      formData.append("upload_location", "REVIEW_INVITE");
      formData.append("review_invite_image", file, file.name);

      let apiData = this.HttpService.postRequest({
        customApiUrl: this.BASE_URL.SOCIAL_UPLOAD(this.outlet_id),
        data: formData,
      });
      apiData.subscribe((data) => {
        if (data.code == 200 || data.code == 201) {
          this.isUploading = false;
          this.media_url = data.data.url;
          variable.variable_value = data.data.url;
          this.emailTemplatePreviewContent();
        } else {
          this.isUploading = false;
          this.media_url = null;
          variable.variable_value = null;
          this.toastrService.error(
            "Oops... something went wrong with the attachment. Please try again."
          );
        }
      });
    }
  }

  removeMediaAttachment(variable) {
    variable.variable_value = null;
    this.emailTemplatePreviewContent();
  }

  convertToTabletPNG() {
    setTimeout(() => {
      this.isDownloadQr = true;

      var node = document.getElementById("qr-tablet-download-section");
      node.style.visibility = "visible";
      node.style.position = "absolute";
      node.style.bottom = "0px";
      node.style.left = "0px";

      htmlToImage
        .toJpeg(node, {
          cacheBust: true,
          backgroundColor: "#fff",
          type: "image/jpeg",
        })
        .then((dataUrl) => {
          var link = document.createElement("a");
          link.download = "qr-tablet.jpeg";
          link.href = dataUrl;
          link.click();
          this.isDownloadQr = false;

          node.style.visibility = "hidden";
          node.style.position = "absolute";
        })
        .catch(function (error) {
          console.error("oops, something went wrong!", error);
        });
    }, 0);
  }

  convertToPocketPNG() {
    setTimeout(() => {
      this.isDownloadQr = true;

      var node = document.getElementById("qr-pocket-download-section");
      node.style.visibility = "visible";
      node.style.position = "absolute";
      node.style.bottom = "0px";
      node.style.left = "0px";

      htmlToImage
        .toJpeg(node, {
          cacheBust: true,
          backgroundColor: "#fff",
          type: "image/jpeg",
        })
        .then((dataUrl) => {
          var link = document.createElement("a");
          link.download = "qr-pocket.jpeg";
          link.href = dataUrl;
          link.click();

          this.isDownloadQr = false;
          node.style.visibility = "hidden";
          node.style.position = "absolute";
        })
        .catch(function (error) {
          console.error("oops, something went wrong!", error);
        });
    }, 0);
  }

  async getFeatures() {
    let reviewFeatures: SubFeatures = await this.featuresByPlan.getFeatures(
      "feature_reviews"
    );
    this.reviewFeatures = reviewFeatures.plan_subfeatures;
    this.isCustomTemplatesAvailable =
      reviewFeatures.plan_subfeatures.custom_invite_template.is_applicable;
    this.requestChannels = Object.keys(
      this.reviewFeatures.review_invite_channel.values
    );
    console.log(this.requestChannels);

    return;
  }

  ngOnInit() {
    this.outlet_id = this.storage.get("outlet_id");
    this.checkInternationalCountry =
      this.storage.get("business_country_name") !== "India";
    this.whatsappInteract();
    this.getFeatures();
    this.getTemplateMetadata();
    this.loading = true;
    let res: Response;
    const setup_value = this.HttpService.get(
      this.BASE_URL.REVIEW_SETUP_VALUE_URL_V2(this.outlet_id)
    );
    setup_value.subscribe((data: Response) => {
      res = data;
      this.default_template_select = res.data["default_sms_template"];
      this.storage.set("default_template_id", res.data["default_sms_template"]);
      this.default_whatsapp_template = res.data["default_whatsapp_template_id"];
      this.isGenericTemplate = res.data["is_generic_template"];

      this.smsMaxLength = res.data["review_sms_template_size"];
      this.smsMaxLength1 = res.data["review_sms_template_size"];

      this.smsMaxLengthEdit =
        res.data["review_sms_template_size"] + this.reviewlinkcount.length;
    });
    this.button_name = "Add";
    this.button_image = "assets/images/add-fff.svg";
    this.value = "https://api.zceppa.com/qrcode/" + this.outlet_id;
    this.reviewTemplateForm = this.formBuilder.group({
      review_title: ["", Validators.compose([Validators.required])],
      review_content: ["", Validators.compose([Validators.required])],
      template_id: [""],
      set_default: [""],
      dlt_template_id: ["", Validators.compose([Validators.required])],
    });
    this.qrCodeSettingForm = this.formBuilder.group({
      brand_logo: ["", Validators.compose([Validators.required])],
      brand_name: ["", Validators.compose([Validators.required])],
      location_name: ["", Validators.compose([Validators.required])],
      description: [""],
      subtitle: [""],
      title: ["", Validators.compose([Validators.required])],
      zceppa_powered: ["", Validators.compose([Validators.required])],
    });
    this.reviewEmailTemplateForm = this.formBuilder.group({
      review_title: ["", Validators.compose([Validators.required])],
      review_content: ["", Validators.compose([Validators.required])],
    });
    this.reviewWhatsappForm = this.formBuilder.group({
      whatsapp_review_title: ["", Validators.compose([Validators.required])],
      whatsapp_review_content: ["", Validators.compose([Validators.required])],
      template_id: [""],
      set_default: [""],
    });
    setTimeout(() => {
      this.commonDataService();
      this.loading = false;
    }, 500);
    const userInfo = this.HttpService.get(
      this.BASE_URL.DASHBOARD_PROFILE_URL(this.outlet_id)
    );
    userInfo.subscribe((data: Response) => {
      res = data;
      this.business_name = res.data["business_name"];
      this.outlet_name = res.data["outlet_name"];
    });

    const data_service = this.HttpService.get(
      this.BASE_URL.GET_LOGO_URL(this.outlet_id)
    );
    data_service.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        // console.log(error);
        if (error.status === 404) {
          this.logo_url = "NO_IMAGE";
        }
      },
      () => {
        let logoUrl = res.data["url"];
        if (logoUrl) {
          const timestamp = new Date().getTime();
          const imageWithTimestamp = logoUrl.includes("?")
            ? `${logoUrl}&v=${timestamp}`
            : `${logoUrl}?v=${timestamp}`;
          logoUrl = imageWithTimestamp;
        }
        this.logo_url = logoUrl;
        // this.storage.set('logo',this.logo_url);
      }
    );

    this.commonservice.logo_image.subscribe((result) => {
      if (result !== null) {
        this.logo_url = result;
      }
    });
    this.checkWhatsAppChannelAvailableInSettings();
  }

  public getTemplateMetadata() {
    this.msgService.getWhatsAppTemplateMetaData().subscribe((data) => {
      if (data.code == 200) {
        this.predefinedVariables = data.data.predefined_variables;
        this.predefinedVariables.forEach((element: any) => {
          element.variable_name = element.label;
          element.variable_value = element.value;
        });
      }
    });
  }

  whatsappInteract() {
    let res: Response;
    const data_service = this.HttpService.get(
      this.BASE_URL.WHATSAPP_VERIFY_V3(this.outlet_id)
    );
    data_service.subscribe((data: Response) => {
      res = data;
      this.interactWhatsapp = res.data["account"].connected;
      this.is_template_approved = res.data["account"].is_template_approved;
      // this.optinTemplate = res.data['account'].details['optin_template'];
    });
  }
  choosetype(e) {
    if (e.target.checked) {
      if (e.target.value === "0") {
        setTimeout(() => {
          this._inputElement.nativeElement.focus();
        }, 1000);
        // console.log('1');
        this.sendMsgSms = false;
        this.sendMsgEmail = false;
        this.sendMsgQr = false;
        this.sendMsgWhatsapp = false;
        this.commonDataService();
        this.emptyFields();
      } else if (e.target.value === "1") {
        // console.log('2');
        this.sendMsgSms = true;
        this.sendMsgEmail = true;
        this.sendMsgQr = false;
        this.sendMsgWhatsapp = false;
        this.commonEmailTemplateDataService();
      } else if (e.target.value === "2") {
        // console.log('3');
        this.sendMsgSms = true;
        this.sendMsgEmail = false;
        this.sendMsgQr = true;
        this.sendMsgWhatsapp = false;
        this.qrCodeSettingsFunction();
      } else if (e.target.value === "3") {
        // console.log('3');
        this.sendMsgSms = true;
        this.sendMsgEmail = false;
        this.sendMsgQr = false;
        this.sendMsgWhatsapp = true;
        // this.commonDataService();
        // this.whatsappTemplates();
        this.getWhatsAppReviewTemplates();
      }
    }
  }

  choosetype1(e) {
    //console.log(e)
    if (e === true) {
      this.brandLogo = true;
    } else {
      this.brandLogo = false;
    }
  }

  choosetype2(e) {
    //console.log(e)
    if (e === true) {
      this.brandName = true;
    } else {
      this.brandName = false;
    }
  }

  chooseLocationName(e) {
    if (e === true) {
      this.locationName = true;
    } else {
      this.locationName = false;
    }
  }

  choosetype3(e) {
    // console.log(e)
    if (e === true) {
      this.powerBy = true;
    } else {
      this.powerBy = false;
    }
  }

  /**
   * Qr code settings function
   *
   * @memberof RequestTemplateComponent
   */
  qrCodeSettingsFunction() {
    let res: Response;
    const qr_code_setting = this.HttpService.get(
      this.BASE_URL.QRCODE_SETTINGS_URL_V2(this.outlet_id)
    );
    qr_code_setting.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        if (error.status === 404) {
          const qr_code_setting_reset = this.HttpService.put(
            this.BASE_URL.QRCODE_SETTINGS_RESET_URL_V2(this.outlet_id)
          );
          qr_code_setting_reset.subscribe(
            (data: Response) => {
              res = data;
            },
            (errors) => {
              this.toastrService.error(errors.error.message);
            },
            () => {
              if (res.code === 200 || res.code === 201) {
                this.qrCodeSettingsFunction();
              } else {
                this.toastrService.error(res.data["message"]);
              }
            }
          );
        }
      },
      () => {
        if (res.code === 200 || res.code === 201) {
          this.qrCodeSettingForm.setValue({
            brand_logo: res.data["brand_logo"],
            brand_name: res.data["brand_name"],
            location_name: res.data["location_name"],
            description: res.data["description"],
            subtitle: res.data["subtitle"],
            title: res.data["title"],
            zceppa_powered: res.data["zceppa_powered"],
          });
          this.brandLogo = res.data["brand_logo"];
          this.brandName = res.data["brand_name"];
          this.locationName = res.data["location_name"];
          this.powerBy = res.data["zceppa_powered"];
          this.show_powered_by_logo = res.data["show_powered_by_logo"];
          this.qrCodeFunction();
          this.loadMyQr();
        } else {
          this.toastrService.error(res.data["message"]);
        }
      }
    );
  }

  /**
   * Get qr code form data
   *
   * @readonly
   * @memberof RequestTemplateComponent
   */
  get qrCodeFormData() {
    return this.qrCodeSettingForm.controls;
  }

  /**
   * QR code genration and display
   *
   * @memberof RequestTemplateComponent
   */
  qrCodeFunction() {
    let res: Response;
    const qr_code_link = this.HttpService.get(
      this.BASE_URL.QRCODE_DISPLAY_URL_V2(this.outlet_id)
    );
    qr_code_link.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        //  console.log(error.error.message);
      },
      () => {
        let qrcode_link = res.data["url"];
        if (qrcode_link) {
          const timestamp = new Date().getTime();
          const imageWithTimestamp = qrcode_link.includes("?")
            ? `${qrcode_link}&v=${timestamp}`
            : `${qrcode_link}?v=${timestamp}`;
          qrcode_link = imageWithTimestamp;
        }
        this.qrcode_link = qrcode_link;
      }
    );
  }

  /**
   * Update qr code settings
   *
   * @param {FormGroup} Form
   * @memberof RequestTemplateComponent
   */
  updateQrCodeSetting(Form: FormGroup) {
    let res: Response;
    //  console.log(Form);
    //  console.log(Form.controls.brand_logo.value);
    this.isValidFormSubmitted = false;
    if (this.qrCodeSettingForm.invalid) {
      return;
    }
    this.isValidFormSubmitted = true;
    const data_json = {
      brand_logo: Form.controls.brand_logo.value,
      brand_name: Form.controls.brand_name.value,
      description: Form.controls.description.value,
      location_name: Form.controls.location_name.value,
      subtitle: Form.controls.subtitle.value,
      title: Form.controls.title.value,
      zceppa_powered: Form.controls.zceppa_powered.value,
    };
    const data_service = this.HttpService.putjson(
      this.BASE_URL.QRCODE_TEMP_UPDATE_URL_V2(this.outlet_id),
      data_json
    );
    data_service.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        this.toastrService.error(error.error.message);
      },
      () => {
        //  console.log(res.data);
        if (res.code === 200 || res.code === 201) {
          this.toastrService.success(res.data["message"]);
        } else {
          this.toastrService.error(res.data["message"]);
        }
      }
    );
  }

  /**
   * Download QR code file
   *
   * @memberof RequestTemplateComponent
   */
  downloadQrcodeFile() {
    window.open(this.qrcode_link, "_blank");
    window.setTimeout(function () {
      this.close();
    }, 1000);
  }

  /**
   * Loads (and generates on first access) the logged-in user's personal review QR.
   * Reviews from scans of this QR are tagged to the logged-in member/owner.
   *
   * @memberof RequestTemplateComponent
   */
  loadMyQr() {
    if (!this.user_id || !this.outlet_id) {
      this.myQrError = "Unable to identify the logged-in user";
      return;
    }
    this.myQrLoading = true;
    this.myQrError = "";
    this.HttpService.get(
      this.BASE_URL.TEAM_QR_READ(this.outlet_id, this.user_id)
    ).subscribe(
      (res: Response) => {
        this.myQrLoading = false;
        if (res.code === 200 && res.data && res.data.url) {
          this.myQrUrl = res.data.url;
        } else {
          this.myQrError = "Unable to load QR code";
        }
      },
      (error) => {
        this.myQrLoading = false;
        this.myQrError = error?.error?.message || "Unable to load QR code";
      }
    );
  }

  // Download the styled personal-QR card as an image (same mechanism as the outlet QR).
  convertMyQrToPNG() {
    setTimeout(() => {
      this.isDownloadMyQr = true;
      const node = document.getElementById("my-qr-section");
      if (!node) {
        this.isDownloadMyQr = false;
        return;
      }
      // The preview is wrapped in a fixed-height perfect-scrollbar (clips at 540px).
      // Expand it to full content height during capture so the whole card is exported,
      // then restore the originals afterwards.
      const scrollEls = node.querySelectorAll<HTMLElement>(
        "perfect-scrollbar, .ps, .ps-content"
      );
      const original: { el: HTMLElement; height: string; overflow: string }[] = [];
      scrollEls.forEach((el) => {
        original.push({
          el,
          height: el.style.height,
          overflow: el.style.overflow,
        });
        el.style.height = "auto";
        el.style.overflow = "visible";
      });
      // Hide the scrollbar rails so they don't appear in the exported image.
      const railEls = node.querySelectorAll<HTMLElement>(
        ".ps__rail-x, .ps__rail-y"
      );
      const railOriginal: { el: HTMLElement; display: string }[] = [];
      railEls.forEach((el) => {
        railOriginal.push({ el, display: el.style.display });
        el.style.display = "none";
      });
      const restore = () => {
        original.forEach((o) => {
          o.el.style.height = o.height;
          o.el.style.overflow = o.overflow;
        });
        railOriginal.forEach((o) => {
          o.el.style.display = o.display;
        });
      };
      htmlToImage
        .toJpeg(node, {
          cacheBust: true,
          backgroundColor: "#fff",
          type: "image/jpeg",
        })
        .then((dataUrl) => {
          const link = document.createElement("a");
          link.download = "my-review-qr.jpeg";
          link.href = dataUrl;
          link.click();
          this.isDownloadMyQr = false;
          restore();
        })
        .catch((error) => {
          console.error("oops, something went wrong!", error);
          this.isDownloadMyQr = false;
          restore();
        });
    }, 0);
  }

  /**
   * Get all data from review form
   *
   * @readonly
   * @memberof RequestTemplateComponent
   */
  get reviewData() {
    return this.reviewTemplateForm.controls;
  }
  setDltValidation() {
    let dlt_template_id = this.reviewTemplateForm.get("dlt_template_id");
    if (!this.checkInternationalCountry) {
      dlt_template_id.setValidators(Validators.required);
    } else {
      dlt_template_id.clearValidators();
    }
    dlt_template_id.updateValueAndValidity();
  }

  /**
   *Add review template
   *
   * @memberof RequestTemplateComponent
   */
  addReviewTemplate(From: FormGroup) {
    const x = new String(From.value["review_content"]);
    // const contentVal = x.length - this.reviewlinkcount.length;
    const contentVal = x.length;
    let cont: String;
    this.isValidFormSubmitted = false;
    console.log(this.reviewTemplateForm.value, "value");
    this.setDltValidation();
    console.log(this.reviewTemplateForm.invalid, "invalid");
    if (this.reviewTemplateForm.invalid) {
      return;
    }
    // console.log(contentVal);console.log(x.length);console.log(this.reviewlinkcount.length);console.log(this.smsMaxLength); return;
    // if (From.controls.template_id.value === '') {
    //   if (x.length > this.smsMaxLength) {
    //     this.toastrService.warning('Message content should not exceed Maximum Characters.');
    //     return;
    //   }
    // } else {
    //   if (contentVal > this.smsMaxLength) {
    //     this.toastrService.warning('Message content should not exceed Maximum Characters.');
    //     return;
    //   }
    // }
    this.isValidFormSubmitted = true;
    let res: Response;
    this.outlet_id = this.storage.get("outlet_id");
    // const val = From.value['review_content'].split('{{review_link}}');
    // this.reviewlinkcount = ' {{review_link}} ';
    // //this.review_contlen = From.value['review_content'];
    // if (val.length <= 1) {
    //   cont = From.value['review_content'] + ' {{review_link}} ';
    // } else {
    //   cont = val[0] + '' + ' {{review_link}} '; // From.value['review_content'];
    // }
    console.log(this.reviewTemplateForm.controls["review_content"].value);

    const val =
      this.reviewTemplateForm.controls["review_content"].value.split(
        "{{review_link}}"
      );
    this.reviewlinkcount = " {{review_link}} ";
    //this.review_contlen = this.reviewTemplateForm.controls['review_content'];
    if (val.length <= 1) {
      cont =
        this.reviewTemplateForm.controls["review_content"].value.trim() +
        " {{review_link}} ";
    } else {
      cont = val[0].trim() + "" + " {{review_link}} " + val[1].trim(); // From.value['review_content'];
    }

    if (From.controls.template_id.value === "") {
      const form_data = {
        title: From.value["review_title"],
        content: cont.trim(),
        dlt_template_id: From.value["dlt_template_id"],
      };
      this.dataService = this.HttpService.post(
        this.BASE_URL.SMS_REVIEW_URL_V2(this.outlet_id),
        form_data
      );
      this.dataService.subscribe(
        (data: Response) => {
          res = data;
        },
        (error) => {
          this.showError(error.error.error_message);
        },
        () => {
          console.log(From.controls.set_default.value);

          if (From.controls.set_default.value === true) {
            const temp = { template_id: From.controls.template_id.value };
            this.HttpService.putjson(
              this.BASE_URL.REVIEW_REQ_UPD_SMS_TEMP_URL_V2(this.outlet_id) +
                From.controls.template_id.value,
              temp
            ).subscribe((data: Response) => {
              res = data;
              this.storage.set(
                "default_template_id",
                From.controls.template_id.value
              );
              this.default_template_select = From.controls.template_id.value;
              console.log(res);
              // this.toastrService.success(res.data['message']);
            });
          }
          this.toastrService.success(res.data["message"]);
          this.update_templates_onChange(
            From.controls.set_default.value,
            From.controls.template_id.value
          );

          // setTimeout(() => {
          //   this.reviewTemplateForm.setValue({
          //     'review_title': '',
          //     'review_content': '',
          //     'template_id': '',
          //     'set_default': ''
          //   });
          // }, 0);
          // this.commonDataService();
          this.commonDataService_changed();
          // this.button_name = 'Add';
          this.checkInternationalCountry && (this.button_name = "Add");

          // this.button_image = 'assets/images/add-fff.svg';
          // this.showSuccess(res.data['message']);
        }
      );
    } else {
      const form_data = {
        title: From.value["review_title"],
        content: cont.trim(),
        id: From.value["template_id"],
        dlt_template_id: From.value["dlt_template_id"],
      };
      this.dataService = this.HttpService.put(
        this.BASE_URL.SMS_REVIEW_UPDATE(this.outlet_id) +
          From.value["template_id"],
        form_data
      );
      this.dataService.subscribe(
        (data: Response) => {
          res = data;
        },
        (error) => {
          this.showError(error.error.error_message);
        },
        () => {
          this.selected_template_id = undefined;
          if (From.controls.set_default.value === true) {
            const temp = { template_id: From.controls.template_id.value };
            this.HttpService.putjson(
              this.BASE_URL.REVIEW_REQ_UPD_SMS_TEMP_URL_V2(this.outlet_id) +
                From.controls.template_id.value,
              temp
            ).subscribe((data: Response) => {
              res = data;
              this.storage.set(
                "default_template_id",
                From.controls.template_id.value
              );
              this.default_template_select = From.controls.template_id.value;
              this.toastrService.success(res.data["message"]);
              this.update_templates_onChange(
                From.controls.set_default.value,
                From.controls.template_id.value
              );
              // this.selected_template_id = this.default_template_select;
              // this.commonDataService();
            });
          } else {
            // this.commonDataService();
            // this.commonDataService_changed();
            this.update_templates_onChange(
              false,
              From.controls.template_id.value
            );
            this.toastrService.success(res.data["message"]);
          }
          // this.commonDataService_changed();
        }
      );
    }
    this.saveTemplate();
  }

  updateWhatsappTemplate(From) {
    let res: Response;

    const val = From.value["whatsapp_review_content"].split("{{review_link}}");
    let cont;
    if (val.length <= 1) {
      cont = From.value["whatsapp_review_content"].trim() + " {{review_link}} ";
    } else {
      cont = val[0].trim() + "" + " {{review_link}} "; // From.value['review_content'];
    }
    const template_id: string = From.value["template_id"];
    this.reviewsService.setReviewInviteDefaultTemplate(template_id).subscribe(
      (data) => {
        res = data;
        if (res.code == 200) {
          console.log(res.data);
          if (From.controls.set_default.value === true) {
            this.storage.set("default_whatsapp_temp_id", template_id);
            this.default_whatsapp_template = template_id;
          }
          this.getWhatsAppReviewTemplates();
          this.toastrService.success(res.data["message"]);
        }
      },
      (error) => {
        this.showError(error.error.error_message);
      },
      () => {}
    );
  }

  /**
   *update templates on change function to show current template
   *
   * @memberof RequestTemplateComponent
   */
  update_templates_onChange(setDefault_value, this_template_id) {
    let trueIndexValue: any[] = [];
    let falseIndexValue: any[] = [];
    const dataService = this.HttpService.get(
      this.BASE_URL.SMS_REVIEW_GET_WP_V2(this.outlet_id)
    );
    dataService.subscribe((res) => {
      let updated_Template = res.data["templates"];
      this.allTemplates = updated_Template;
      this.allTemplates.forEach((val) => {
        if (val.default === true) {
          trueIndexValue.push(val);
        } else {
          falseIndexValue.push(val);
        }
        this.zceppaTemplatesSMS = trueIndexValue;
        this.customTemplatesSMS = falseIndexValue;
        this.zceppaTempLen = trueIndexValue.length;
        this.customTempLen = falseIndexValue.length;
        if (trueIndexValue.length === 0) {
          this.showNoDefaultTemplate = true;
        } else {
          this.showNoDefaultTemplate = false;
        }

        if (falseIndexValue.length === 0) {
          this.showNoCustomTemplate = true;
        } else {
          this.showNoCustomTemplate = false;
        }
        // })
        if (setDefault_value === true || setDefault_value !== "") {
          if (val.id === this_template_id) {
            this.onSelectTemplate(val);
          }
        } else {
          console.log("testfuncelse");
          let last_updated = updated_Template[updated_Template.length - 1];
          this.onSelectTemplate(last_updated);
        }
      });
    });
  }

  copyAsNewTemplate(From: FormGroup) {
    const x = new String(From.value["review_content"]);
    const contentVal = x.length;
    if (contentVal === 0) {
      this.toastrService.warning("Message content should not be empty.");
      this.modalService.dismissAll("saveAsNewTemplateModel");
      return;
    }
    if (From.value["review_title"] == "") {
      this.toastrService.warning("Message title should not be empty.");
      this.modalService.dismissAll("saveAsNewTemplateModel");
      return;
    }
    if (contentVal > this.smsMaxLength) {
      this.toastrService.warning(
        "Message content should not exceed Maximum Characters."
      );
      this.modalService.dismissAll("saveAsNewTemplateModel");
      return;
    }
    let res: Response;
    let cont: String;
    console.log(this.reviewTemplateForm);
    console.log(From.controls["review_content"].value);
    console.log(From);

    const val = From.controls["review_content"].value.split("{{review_link}}");
    // const val = From.controls["review_content"].value;
    this.reviewlinkcount = " {{review_link}} ";
    if (val.length <= 1) {
      cont = From.controls["review_content"].value.trim() + " {{review_link}} ";
    } else {
      cont = val[0].trim() + "" + " {{review_link}} "; // From.value['review_content'];
    }

    const form_data = {
      title: From.value["review_title"],
      content: cont.trim(),
      dlt_template_id: From.value["dlt_template_id"],
    };
    this.dataService = this.HttpService.post(
      this.BASE_URL.SMS_REVIEW_URL_V2(this.outlet_id),
      form_data
    );
    this.dataService.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        this.showError(error.error.error_message);
      },
      () => {
        this.toastrService.success(res.data["message"]);

        const dataService = this.HttpService.get(
          this.BASE_URL.SMS_REVIEW_GET_WP_V2(this.outlet_id)
        );

        forkJoin(dataService).subscribe((res) => {
          let updated_Template = res[0].data["templates"];
          let last_updated = updated_Template[updated_Template.length - 1];
          if (
            From.controls.set_default.value === true ||
            (From.controls.set_default.value === false &&
              this.default_template_select !== this.selected_template_id) ||
            (From.controls.set_default.value === "" &&
              this.default_template_select === this.selected_template_id) ||
            From.controls.set_default.value === this.default_template_select
          ) {
            const temp = { template_id: last_updated["id"] };
            this.HttpService.putjson(
              this.BASE_URL.REVIEW_REQ_UPD_SMS_TEMP_URL_V2(this.outlet_id) +
                last_updated["id"],
              temp
            ).subscribe((data) => {
              this.storage.set("default_template_id", temp.template_id);
              this.default_template_select = temp.template_id;
              this.selected_template_id = this.default_template_select;
            });
          }
          this.commonDataService_changed();
          this.onSelectTemplate(last_updated);
        });

        // this.checkModel = null;
        // this.showSuccess(res.data['message']);
      }
    );
    this.modalService.dismissAll("saveAsNewTemplateModel");
  }

  preSelectTemplate() {
    this.allTemplates.forEach((_, i) => {
      if (_.id == this.default_template_select) {
        this.isDefaultTemplate = _.default;
        this.onSelectTemplate(_);
      }
    });
  }

  /**
   * Edit template
   *
   * @param {*} template
   * @param {*} i
   * @memberof RequestTemplateComponent
   */
  onSelectTemplate(template, iswhatsapp: boolean = false) {
    this.show_button1 = true;
    this.saveAsNewTemplateButton = true;
    this.reviewTemplateForm.controls["review_title"].disable();
    this.reviewWhatsappForm.controls["whatsapp_review_title"].disable();
    if (this.isGenericTemplate) {
      this.reviewTemplateForm.controls["dlt_template_id"].disable();
      this.reviewTemplateForm.controls["set_default"].disable();
    } else {
      this.reviewTemplateForm.controls["dlt_template_id"].enable();
      this.reviewTemplateForm.controls["set_default"].enable();
    }

    this.isApprovedTemplate = template.is_approved;
    this.selectedTemplate = template;
    // this.reviewWhatsappForm.controls['whatsapp_review_content'].disable();
    this.selected_template_id = template.id;

    // const x = new String(this.reviewTemplateForm);
    // console.log('x len',x.length);
    //  this.smsMaxLength = this.smsMaxLengthEdit;
    // console.log('this.smsMaxLength',this.smsMaxLength);
    let content = template.content;
    let x = content.split("{{review_link}}");
    if (template.default === true) {
      this.reviewTemplateForm.controls["review_content"].disable();
      this.show_button = true;
      console.log("template default true");
    } else {
      this.reviewTemplateForm.controls["review_content"].enable();
      this.show_button = false;
    }

    // console.log(x[0]);
    //console.log(' this.show_button', this.show_button);
    if (iswhatsapp) {
      if (this.selected_template_id === this.default_whatsapp_template) {
        console.log("is whatsapp default");
        this.reviewWhatsappForm.setValue({
          whatsapp_review_title: template.title,
          whatsapp_review_content: content,
          template_id: template.id,
          set_default: template.id,
        });
      } else {
        console.log("is whatsapp not default");
        this.reviewWhatsappForm.setValue({
          whatsapp_review_title: template.title,
          whatsapp_review_content: content,
          template_id: template.id,
          set_default: "",
        });
      }
    } else {
      if (this.selected_template_id === this.default_template_select) {
        this.reviewTemplateForm.setValue({
          review_title: template.title,
          review_content: content,
          template_id: template.id,
          set_default: template.id,
          dlt_template_id: template.dlt_template_id ?? "",
        });
      } else {
        console.log("is called");

        this.reviewTemplateForm.setValue({
          review_title: template.title,
          review_content: content,
          template_id: template.id,
          set_default: "",
          dlt_template_id: template.dlt_template_id ?? "",
        });
      }
    }

    // this.reviewTemplateForm.controls['review_title'].disable();
    this.button_name = "Save";
    this.button_image = "assets/images/save-file-option.svg";
  }
  /**
   *
   * @param saveAsNewTemplateModel
   * @memberof RequestTemplateComponent
   */

  saveAsNewTemplate(saveAsNewTemplateModel) {
    this.show_button1 = false;
    this.reviewTemplateForm.controls["review_title"].enable();
    this.modalService
      .open(saveAsNewTemplateModel, {
        ariaLabelledBy: "saveAsNewTemplateModel",
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          // this.saveAsNewTemplateButton = false;
          this.reviewTemplateForm.controls["review_title"].disable();
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  /**
   * Delete popup
   *
   * @param {*} template
   * @param {*} content
   * @param {*} index
   * @memberof RequestTemplateComponent
   */
  onDeleteTemplate(templateId) {
    this.template_id = templateId;

    this.alertService
      .alertWithDeleteImage(
        "Delete Template",
        "Are you sure you want to delete the template?",
        "Delete"
      )
      .then((data) => {
        if (data.isConfirmed) {
          this.deleteTemplate();
        }
      });
  }

  /**
   * Delete template
   *
   * @memberof RequestTemplateComponent
   */
  deleteTemplate() {
    let res: Response;
    this.outlet_id = this.storage.get("outlet_id");
    const dataService = this.HttpService.delete(
      this.BASE_URL.SMS_REVIEW_DELETE_V2(this.outlet_id) + this.template_id,
      this.template_id
    );
    dataService.subscribe(
      (data: Response) => {
        res = data;
        //  console.log(res.data);
      },
      (error) => {
        this.showError(error.error.error_message);
      },
      () => {
        this.reviewTemplateForm.patchValue({
          review_title: "",
          review_content: "",
          template_id: "",
          set_default: "",
        });

        // if (this.role === 'Manager') {
        //   this.show_button = true;
        // } else {
        //   this.show_button = false;
        // }
        this.selected_template_id = undefined;
        this.checkInternationalCountry && (this.button_name = "Add");
        this.button_image = "assets/images/add-fff.svg";
        this.modalService.dismissAll("content");
        this.showSuccess("Template deleted successfully");
        this.emptyFields();
        // this.showSuccess(res.data['message']);
        // this.review_template.splice(this.last_index, 1);
        this.commonDataService_changed();
      }
    );
  }

  /**
   *common data service function for listing template
   *
   * @memberof RequestTemplateComponent
   */
  commonDataService() {
    let res: Response;
    let trueIndexTemplates: any[] = [];
    let falseIndexTemplates: any[] = [];
    this.outlet_id = this.storage.get("outlet_id");
    const dataService = this.HttpService.get(
      this.BASE_URL.SMS_REVIEW_GET_WP_V2(this.outlet_id)
    );
    dataService.subscribe((data: Response) => {
      res = data;
      this.permissions = res.data["permissions"];
      this.allTemplates = res.data["templates"];
      this.allTemplates = this.allTemplates.map((_) => {
        _.dlt_template_id = _.dlt_template_id ?? "";
        return _;
      });
      this.showDltWarning = this.allTemplates.every(
        (_) => _.is_approved == null || _.is_approved == false
      );
      console.log(this.allTemplates);
      this.allTemplates.forEach((val: any) => {
        if (val.default === true) {
          trueIndexTemplates.push(val);
        } else {
          falseIndexTemplates.push(val);
        }
      });
      this.zceppaTemplatesSMS = trueIndexTemplates;
      this.customTemplatesSMS = falseIndexTemplates;

      this.zceppaTempLen = trueIndexTemplates.length;
      this.customTempLen = falseIndexTemplates.length;
      if (trueIndexTemplates.length === 0) {
        this.showNoDefaultTemplate = true;
      } else {
        this.showNoDefaultTemplate = false;
      }

      if (falseIndexTemplates.length === 0) {
        this.showNoCustomTemplate = true;
      } else {
        this.showNoCustomTemplate = false;
      }
      this.preSelectTemplate();
    });
  }

  commonDataService_changed() {
    let res: Response;
    let trueIndexTemplates: any[] = [];
    let falseIndexTemplates: any[] = [];
    this.outlet_id = this.storage.get("outlet_id");
    const dataService = this.HttpService.get(
      this.BASE_URL.SMS_REVIEW_GET_WP_V2(this.outlet_id)
    );
    dataService.subscribe((data: Response) => {
      res = data;
      this.allTemplates = res.data["templates"];
      this.allTemplates = this.allTemplates.map((_) => {
        _.dlt_template_id = _.dlt_template_id ?? "";
        return _;
      });
      this.showDltWarning = this.allTemplates.every(
        (_) => _.is_approved == null || _.is_approved == false
      );
      console.log(this.allTemplates);
      this.allTemplates.forEach((val: any) => {
        if (val.default === true) {
          trueIndexTemplates.push(val);
        } else {
          falseIndexTemplates.push(val);
        }
      });
      this.zceppaTemplatesSMS = trueIndexTemplates;
      this.customTemplatesSMS = falseIndexTemplates;

      this.zceppaTempLen = trueIndexTemplates.length;
      this.customTempLen = falseIndexTemplates.length;
      if (trueIndexTemplates.length === 0) {
        this.showNoDefaultTemplate = true;
      } else {
        this.showNoDefaultTemplate = false;
      }

      if (falseIndexTemplates.length === 0) {
        this.showNoCustomTemplate = true;
      } else {
        this.showNoCustomTemplate = false;
      }
    });
    // if (this.role === 'Manager') {
    //   this.show_button = true;
    // } else {
    //   this.show_button = false;
    // }
  }

  get whatsappForm() {
    return this.reviewWhatsappForm.controls;
  }
  /*
   * whatsapp templates
   */
  whatsappTemplates() {
    let res: Response;
    this.outlet_id = this.storage.get("outlet_id");
    let trueIndexValue: any = [];
    let falseIndexValue: any = [];
    const whatsapptemplate = this.HttpService.get(
      this.BASE_URL.WHATSAPP_TEMP(this.outlet_id)
    );
    whatsapptemplate.subscribe((data: Response) => {
      res = data;
      this.whatsappTempList = res.data["templates"];
      this.whatsappTempList.forEach((val, key) => {
        // this.reviewWhatsappForm.setValue({
        //   'whatsapp_review_title': 'test',
        //   'whatsapp_review_content': '',
        //   'template_id': '',
        //   'set_default': ''
        // });
        if (val.default === true) {
          trueIndexValue.push(key);
        } else {
          falseIndexValue.push(key);
        }
        if (val.id === this.default_whatsapp_template) {
          this.onSelectTemplate(val, true);
        } else {
        }
      });
      if (trueIndexValue.length === 0) {
        this.showNoDefaultTemplate = true;
      } else {
        this.showNoDefaultTemplate = false;
      }
      if (falseIndexValue.length === 0) {
        this.showNoCustomTemplate = true;
      } else {
        this.showNoCustomTemplate = false;
      }

      // if (this.role === 'Manager') {
      //   this.show_button = true;
      // } else {
      //   this.show_button = false;
      // }
      // console.log(this.whatsappTempList , "whatsapptemplist");
    });
  }

  getWhatsAppReviewTemplates() {
    let trueIndexValue: any = [];
    let falseIndexValue: any = [];
    this.reviewsService.getReviewInviteTemplate().subscribe(
      (data: Response) => {
        this.whatsappTempList = data.data.templates;
        this.whatsappTempList.forEach((val, key) => {
          if (val.default === true) {
            trueIndexValue.push(key);
          } else {
            falseIndexValue.push(key);
          }
          if (val.id === this.default_whatsapp_template) {
            // set template data in from like title desc etc
            this.onSelectTemplate(val, true);
          }
        });
        if (trueIndexValue.length === 0) {
          this.showNoDefaultTemplate = true;
        } else {
          this.showNoDefaultTemplate = false;
        }
        if (falseIndexValue.length === 0) {
          this.showNoCustomTemplate = true;
        } else {
          this.showNoCustomTemplate = false;
        }
      },
      (err: any) => {
        console.log("error==>>", err);
      }
    );
  }

  /**
   * Get all data from review Email form
   *
   * @readonly
   * @memberof RequestTemplateComponent
   */
  get reviewEmailData() {
    return this.reviewEmailTemplateForm.controls;
  }

  /**
   * Edit template
   *
   * @param {*} template
   * @param {*} i
   * @memberof RequestTemplateComponent
   */
  editEmailTemplate(template) {

    this.reviewEmailTemplateForm.patchValue({
      review_title: template.template_display_name,
      review_content: template.preview_html_template,
    });
    this.selectedTemplate = template;

    this.emailTemplatePreviewContent();

    this.button_name = "Save";
    this.button_image = "assets/images/save-file-option.svg";
  }

  emailTemplatePreviewContent() {
    const img_name = "{{business_logo}}";
    const b_name = "{{business_name}}";
    const c_name = "{{customer_name}}";
    const l_name = "{{review_link}}";
    const profile_name = "{{profile_name}}";
    const profile_photo = "{{profile_photo}}";
    const profile_detail = "{{profile_detail}}";
    let profile_name_value = "";
    let profile_photo_value = "";
    let profile_detail_value = "";

    if (this.selectedTemplate?.dynamic_variables) {
      this.selectedTemplate.dynamic_variables =
        this.selectedTemplate.dynamic_variables
          .map((el) => {
            let variable_name = `{{${el.variable_name}}}`;
            if (variable_name == profile_name) {
              let variableValue = el?.variable_value || el?.variable_display_name;
              profile_name_value = variableValue;
              el.sort_order = 1;
            } else if (variable_name == profile_detail) {
              let variableValue = el?.variable_value || el?.variable_display_name;
              profile_detail_value = variableValue;
              el.sort_order = 2;
            } else if (variable_name == profile_photo) {
              let variableValue = el?.variable_value || "assets/images/man-user.svg";
              profile_photo_value = variableValue;
              el.sort_order = 3;
            }
            return el;
          })
          .sort((a, b) => a.sort_order - b.sort_order);
    }

    this.reviewlinkcount = " {{review_link}} ";
    const str = this.selectedTemplate?.preview_html_template;
    const strdata =
      this.logo_url === "NO_IMAGE"
        ? str.replace(img_name, this.business_temp_logo)
        : str.replace(img_name, this.storage.get("logo"));
    const strdata1 = strdata.replace(b_name, this.storage.get("business_name"));
    const strdata2 = strdata1.replace(c_name, "Customer name appears here");
    const strdata3 = strdata2.replace(l_name, "Review link appears here");
    const strdata4 = strdata3.replace(l_name, "Review link appears here");
    const strdata5 = strdata4.replace(profile_name, profile_name_value);
    const strdata6 = strdata5.replace(profile_detail, profile_detail_value);
    const strdata7 = strdata6.replace(profile_photo, profile_photo_value);

    this.email_template_html_data = strdata7;
  }

  updateEmailTemplateSubmit() {
    let template_id = this.selectedTemplate?.template_id;
    let dynamic_variables;
    if (!this.selectedTemplate?.dynamic_variables?.length) {
      return;
    }
    if (this.selectedTemplate?.dynamic_variables?.length) {
      dynamic_variables = this.selectedTemplate.dynamic_variables.map(
        (variable) => {
          variable.variable_id = variable.variable_id;
          variable.variable_name = variable.variable_name;
          variable.variable_value = variable.variable_value;
          return variable;
        }
      );
    }

    let payload = {
      dynamic_variables: dynamic_variables,
    };
    this.HttpService.putRequest({
      customApiUrl: this.BASE_URL.EMAIL_REVIEW_INVITE_URL(
        this.outlet_id,
        template_id
      ),
      data: payload,
    }).subscribe((res) => {
      if (res.code == 200) {
        this.showSuccess(res.data["message"]);
        this.commonEmailTemplateDataService(3);
      }
    });
  }

  /**
   *common data service function for listing email template
   *
   * @memberof RequestTemplateComponent
   */
  commonEmailTemplateDataService(templateIndexOnUpdate = 0) {
    let res: Response;
    this.outlet_id = this.storage.get("outlet_id");
    const dataService = this.HttpService.get(
      this.BASE_URL.EMAIL_REVIEW_URL(this.outlet_id)
    );
    dataService.subscribe((data: Response) => {
      res = data;
      this.emailTemplates = res.data["templates"];
      this.emailTemplates.map((el, index) => {
        el.title = `Invite Template ${index + 1}`;
        el.id = `invite_template_${index + 1}`;
        el.temp_id = el.id;
        el.dynamic_variables = el.dynamic_variables;
        el.preview_html_template = el.preview_html_template;
        el.content = ``;
        return el;
      });
      this.editEmailTemplate(this.emailTemplates[templateIndexOnUpdate]);
    });
  }

  /**
   * Open model service function
   *
   * @param {*} content
   * @memberof RequestTemplateComponent
   */
  open(content) {
    this.modalService
      .open(content, { ariaLabelledBy: "modalreviewadd" })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  /**
   * Close popup model
   *
   * @private
   * @param {*} reason
   * @returns {string}
   * @memberof RequestTemplateComponent
   */
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  /**
   * Remove validation
   */
  removeValidation(e) {
    this.isValidFormSubmitted = true;
    // const key = e.charCode ? e.charCode : e.keyCode;
    // if (key === 46) {
    //   return false;
    // }
  }

  /**
   * Empty fields
   *
   * @memberof RequestTemplateComponent
   */
  emptyFields() {
    this.show_button1 = false;
    this.show_button = false;
    this.saveAsNewTemplateButton = false;
    this.selected_template_id = undefined;
    this.selectedTemplate = null;
    this.smsMaxLength = 130;
    // if (this.checkInternationalCountry) {
    this.reviewTemplateForm.controls["review_title"].enable();
    this.reviewTemplateForm.controls["review_content"].enable();
    this.button_name = "Add";
    this.button_image = "assets/images/add-fff.svg";
    this.reviewTemplateForm.patchValue({
      review_title: "",
      review_content: "",
      template_id: "",
      set_default: "",
      dlt_template_id: "",
    });
    // }

    // this.reviewWhatsappForm.setValue({
    // 'whatsapp_review_title': '',
    // 'whatsapp_review_content': '',
    // 'template_id': '',
    // 'set_default': ''
    // });
    // if (this.role === 'Manager') {
    //   this.show_button = true;
    // } else {
    //   this.show_button = false;
    // }
  }

  /**
   *Common toastr for success function
   *
   * @param {string} msg
   * @memberof RequestTemplateComponent
   */
  showSuccess(msg: string) {
    this.toastrService.success(msg);
  }

  /**
   * Common toastr for error function
   *
   * @param {string} msg
   * @memberof RequestTemplateComponent
   */
  showError(msg: string) {
    this.toastrService.error(msg);
  }

  saveTemplate() {
    this.selected_template_id = undefined;
    this.show_button1 = false;
    this.reviewTemplateForm.controls["review_title"].disable();
    // setTimeout(() => {
    //   this.show_button1 = false;
    //   this.emptyFields();
    //   }, 3000);
  }

  style = {
    div: {
      "text-align": "center",
      margin: "5% 25%",
    },
    ".qrshowhide": {
      border: "8px solid #03c0c2",
    },
    ".printsec": {
      "margin-top": "15px",
      "text-align": "center",
      color: "#4a4a4a",
    },
    ".logourl": {
      width: "74px",
      height: "44px",
      "object-fit": "cover",
    },
    ".phimgsec": {
      display: "none",
    },
    h4: {
      color: "#03c0c2",
      "font-weight": "600",
      "font-size": "1.21875rem",
    },

    ".scanreview": {
      color: "blueviolet",
      "font-size": "14px",
      "font-weight": "600",
      "text-align": "center",
    },
    ".scanreviewp": {
      "font-size": "10px",
      "padding-top": "15px",
      "text-align": "center",
      width: "100%",
    },
    ".powerdbylogo": {
      width: "100px",
    },
    ".qrimage": {
      width: "150px",
    },
  };

  saveReviewTemp() {
    const form_data = {
      brand_logo: this.brandLogo,
      brand_name: this.brandName,
      location_name: this.locationName,
      description: this.reviewData.scan_to_message.value,
      subtitle: this.reviewData.scan_subtitle.value,
      title: this.reviewData.scan_to_review.value,
      zceppa_powered: this.powerBy,
    };
    //console.log(form_data);
    //console.log('form_data');
    let res: Response;
    this.HttpService.put(
      this.BASE_URL.QRCODE_TEMP_UPDATE_URL_V2(this.outlet_id),
      form_data
    ).subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        this.toastrService.error(error);
      },
      () => {
        // console.log(res);
      }
    );
  }

  checkWhatsAppChannelAvailableInSettings() {
    this.HttpService.get(
      this.BASE_URL.REVIEW_SETUP_URL_V2(this.outlet_id)
    ).subscribe(
      (data) => {
        let request_channel = data.data["request_channel"];
        if (request_channel && request_channel.includes("WhatsApp")) {
          this.isWhatsAppChannelAvailableInSettings = true;
        } else {
          this.isWhatsAppChannelAvailableInSettings = false;
        }
      },
      (error) => {
        console.log("error", error);
      }
    );
  }

  onSelectDynamicVariableFromModal(variableData) {
    let contentData = this.reviewTemplateForm.controls["review_content"].value;
    let updatedData = contentData + " " + variableData?.variable_name;
    this.reviewTemplateForm.patchValue({
      review_content: updatedData,
    });
    // this.onContentChange();
  }
}
